/**
 * Header decoration/icon for a preference type category.
 *
 * Belongs here: header SVG or fund list UI.
 * Does not belong here: questionnaire flow.
 */
interface HeaderProgressBarProps {
  progressValue: number
}

export function HeaderProgressBar({ progressValue }: HeaderProgressBarProps) {
  return (
    <div className="mt-3 h-[6px] w-full overflow-hidden rounded-full bg-white">
      <div
        className="h-full rounded-full bg-[#232323] transition-[width] duration-200 ease-out motion-reduce:transition-none"
        style={{ width: `${progressValue * 100}%` }}
      />
    </div>
  )
}
